import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1 from '@upr-web-primer/storage';
import get from 'lodash-es/get';
class TestingService {
  constructor(sessionStorageService) {
    this.sessionStorageService = sessionStorageService;
    if (this.isTruthy('TEST')) {
      this.isGlobalTestMode = true;
    }
  }
  isTestMode(key = '') {
    return this.isGlobalTestMode || this.isTruthy(key);
  }
  getMockResponse(endpoint, method, code, mockData) {
    const path = `${endpoint}.${method}.${code}`;
    const mock = get(mockData, path);
    if (!mock) {
      console.error(`[TESTING]: Could not find data in Mock, path requested: ${path}`);
      return {};
    }
    return mock;
  }
  // SHOULD BE PART OF SESSION STORAGE
  isTruthy(key = '') {
    if (!key) {
      return false;
    }
    const testMode = (this.sessionStorageService.getItem(key) || '').toLowerCase();
    return testMode === 'true' || testMode === '1';
  }
  makeRequest(endpoint, method, testStatusSessionStorageKey, mockData) {
    const status = testStatusSessionStorageKey ? Number(this.sessionStorageService.getItem(testStatusSessionStorageKey)) || 200 : 200;
    if (status === 200 || status === 201 || status === 204) {
      return Promise.resolve(this.getMockResponse(endpoint, method, status, mockData));
    } else {
      return Promise.reject(this.getMockResponse(endpoint, method, status, mockData));
    }
  }
  static {
    this.ɵfac = function TestingService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TestingService)(i0.ɵɵinject(i1.SessionStorageService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: TestingService,
      factory: TestingService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TestingService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.SessionStorageService
  }], null);
})();

/**
 * THE IDEA IS TO KEEP; ADDING AND HAVE ALL ENDPOINTS MOCKED HERE,
 * THEN WE CAN REUSE THIS VARIABLE ACROSS ALL WEB APPS TO HAVE MOCKING SUITE CENTRALIZED
 * WE CAN STILL PROVIDE A LOCAL VALUE IF WE WANT FROM THE APP ITSELF.
 */
const ServicesEndpointsMock = {
  /** EXAMPLE SERVICE MOCK */
  ExampleService: {
    '/test-example-endpoint': {
      GET: {
        200: {
          email: 'user@example.com',
          status: 'active'
        },
        404: {
          status: 'Not Found',
          code: 404
        },
        500: {
          status: 'Internal Server Error',
          code: 500
        }
      },
      POST: {
        200: {
          email: 'user@example.com',
          status: 'active'
        },
        404: {
          status: 'Not Found',
          code: 404
        },
        500: {
          status: 'Internal Server Error',
          code: 500
        }
      },
      PUT: {
        200: {
          email: 'user@example.com',
          status: 'active'
        },
        404: {
          status: 'Not Found',
          code: 404
        },
        500: {
          status: 'Internal Server Error',
          code: 500
        }
      },
      DELETE: {
        200: {
          email: 'user@example.com',
          status: 'active'
        },
        404: {
          status: 'Not Found',
          code: 404
        },
        500: {
          status: 'Internal Server Error',
          code: 500
        }
      }
    }
  },
  /** ADD YOUR MOCKS FROM HERE FOLLOWING THE EXAMPLE ABOVE */
  FTC: {
    '/resort-areas/{resort-area-code}/find-subscription-contract': {
      POST: {
        200: {
          email: 'user@example.com',
          contract_id: '67',
          status: 'active',
          auto_renewal: true,
          is_contract_year_one: false,
          expiration_date: '2025-12-31',
          remaining_payments: 5,
          next_payment_date: '2024-06-15',
          payment_contract_renew_date: '2025-01-01',
          linked_passes: [{
            first_name: 'Mary-Lynn',
            last_name: "O'Brian",
            plu: 'PLU1234',
            pass_description: '2-Park 12-Month Power Adult Non-Resident Pass',
            pass_id: '13651454519643869'
          }]
        },
        404: {
          detail: 'Invalid user input',
          instance: 'string',
          invalid_parms: [{
            field: 'string',
            rule: 'string',
            rule_code: ['string']
          }],
          problem: 'validation-error',
          title: 'Your request parameters did not validate',
          type: 'https://services.use.ucdp.net/carts/validation-error'
        },
        500: {
          error: 'Internal Server Error'
        }
      }
    },
    '/resort-areas/{resort-area-code}/cancel-subscription-contract': {
      POST: {
        200: {
          order_confirmation_number: 'U04563598',
          first_name: 'Mary-Lynn',
          last_name: "O'Brian",
          last_four: '1234',
          contract_id: 'CONTRACT12345',
          status: 'canceled',
          auto_renew_status: 'disabled',
          pass_expiration_updated: true,
          restore_subscription_at: '2025-01-15T12:00:00Z'
        },
        404: {
          error: 'Not Found'
        },
        500: {
          error: 'Internal Server Error'
        }
      }
    }
  }
};

/*
 * Public API Surface of testing
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ServicesEndpointsMock, TestingService };
